export enum TypesEnum {
    FILE = 'FILE',
    DIRECTORY = 'DIRECTORY',
}

export enum SharedTypeEnum {
    USER = 'user',
    GROUP = 'group',
}
